import { ButtonIcon, css, DownIcon, styled, Tooltip } from 'canoe';
import React from 'react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';

const IconDirection = styled.div<{ direction: 'left' | 'right' }>`
  ${({ direction }) => css`
    ${direction === 'left' &&
    css`
      transform: rotate(90deg);
    `}
    ${direction === 'right' &&
    css`
      transform: rotate(-90deg);
    `}
  `}
`;

export const ReorderButton = ({
  tooltipPlacement,
  direction,
  disabled,
  onClick,
}: {
  tooltipPlacement: 'top' | 'bottom';
  direction: 'left' | 'right';
  disabled: boolean;
  onClick: VoidFunction;
}) => {
  return (
    <Tooltip
      placement={tooltipPlacement}
      offset="xxs"
      content={<TooltipBodyWithShortcuts content={`Move ${direction}`} />}
      disabled={disabled}
    >
      <IconDirection direction={direction}>
        <ButtonIcon
          size="small"
          icon={DownIcon}
          onClick={onClick}
          disabled={disabled}
          radius="small"
          color="white"
        />
      </IconDirection>
    </Tooltip>
  );
};
